import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ConfigService } from '../service/config.service';

export const loginRedirectGuard: CanActivateFn = (next, state) => {
  const config = inject(ConfigService);

  if (config.appConfig.urlLoginRedirect) {
    const paramsString = state.url.split('?')[1];
    window.location.href =
      config.appConfig.urlLoginRedirect + '?' + paramsString;
    return false;
  } else {
    return true;
  }
};
